import React, { useContext, useState } from "react";
import { AppContextType, WonmovContext } from "@/context/app-context";
import TextField from "@/component/widgets/text-field";
import { userRepo } from "@/repo/user-repo";
import AvatarWidget from "@/component/commom/avatar-widget";
import AvatarPickerDialog from "@/pages-app/profile/edit/_components/avatar-picker-dialog";

export default function EditProfilePage() {
    const { user, setUser, setNotification } = useContext<AppContextType>(WonmovContext);

    const [avatar, setAvatar] = useState(user?.avatar ?? 1);
    const [username, setUsername] = useState(user?.username ?? "");
    const [name, setName] = useState(user?.name ?? "");
    const [email, setEmail] = useState(user?.email ?? "");
    const [phone, setPhone] = useState(user?.phone ?? "");
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [openAvatarPicker, setOpenAvatarPicker] = useState(false);

    const handleUpdateProfile = async () => {
        if (isLoading) return;
        if (!username.trim()) {
            setNotification({ type: "danger", message: "نام کاربری را وارد کنید" });
            return;
        }
        if (!name.trim()) {
            setNotification({ type: "danger", message: "نام را وارد کنید" });
            return;
        }
        if (!email.trim()) {
            setNotification({ type: "danger", message: "ایمیل را وارد کنید" });
            return;
        }
        setIsLoading(true);
        const res = await userRepo.updateProfile(username, name, email, phone, avatar);
        if (!res.status) {
            setNotification({ type: "danger", message: res.message });
            setIsLoading(false);
            return;
        }
        setUser(res.data!);
        setAvatar(res.data!.avatar);
        setNotification({ type: "success", message: "پروفایل با موفقیت ویرایش شد" });
        setIsLoading(false);
    }

    const handleUpdatePassword = async () => {
        if (isLoading) return;
        if (oldPassword.trim().length < 8) {
            setNotification({ type: "danger", message: "رمز عبور قدیمی باید حداقل 8 کاراکتر باشد" });
            return;
        }
        if (newPassword.trim().length < 8) {
            setNotification({ type: "danger", message: "رمز عبور جدید باید حداقل 8 کاراکتر باشد" });
            return;
        }
        if (confirmPassword.trim().length < 8) {
            setNotification({ type: "danger", message: "تایید رمز عبور باید حداقل 8 کاراکتر باشد" });
            return;
        }
        if (newPassword !== confirmPassword) {
            setNotification({ type: "danger", message: "رمز عبور جدید و تایید رمز عبور مطابقت ندارند" });
            return;
        }
        setIsLoading(true);
        const res = await userRepo.updatePassword(oldPassword, newPassword);
        if (!res.status) {
            setNotification({ type: "danger", message: res.message });
            setIsLoading(false);
            return;
        }
        setNotification({ type: "success", message: "رمز عبور با موفقیت ویرایش شد" });
        setIsLoading(false);
    }

    return (
        <>
        <div className="profile-panel profile-edit">
            <div className="profile-edit__avatar-wrap">
                <AvatarWidget
                    avatar={avatar}
                    className="profile-edit__avatar"
                    onClick={() => setOpenAvatarPicker(true)}
                />
            </div>

            <h2 className="profile-panel__title profile-edit__title">ویرایش پروفایل</h2>

            <div className="profile-edit__form">
                <div className="profile-edit__field">
                    <TextField
                        name="username"
                        value={username}
                        placeholder="نام کاربری"
                        label="نام کاربری"
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>
                <div className="profile-edit__field">
                    <TextField
                        name="name"
                        value={name}
                        placeholder="نام و نام خانوادگی"
                        label="نام و نام خانوادگی"
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
                <div className="profile-edit__field">
                    <TextField
                        name="email"
                        value={email}
                        placeholder="ایمیل"
                        label="ایمیل"
                        type="email"
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div className="profile-edit__field">
                    <TextField
                        name="phone"
                        value={phone}
                        type="tel"
                        placeholder="شماره همراه"
                        label="شماره همراه"
                        onChange={(e) => setPhone(e.target.value)}
                    />
                </div>

                <div className="profile-edit__actions">
                    <button
                        type="button"
                        className="profile-edit__submit"
                        onClick={handleUpdateProfile}
                        disabled={isLoading}
                    >
                        {isLoading ? <div className="loader"></div> : "ویرایش پروفایل"}
                    </button>
                </div>
            </div>

            <h2 className="profile-panel__title profile-edit__title profile-edit__title--spaced">ویرایش رمز عبور</h2>
            <div className="profile-edit__form">
                <div className="profile-edit__field profile-edit__field--full">
                    <TextField
                        name="old-password"
                        value={oldPassword}
                        placeholder="رمز عبور قدیمی"
                        onChange={(e) => setOldPassword(e.target.value)}
                        type="password"
                        label="رمز عبور قدیمی"
                    />
                </div>
                <div className="profile-edit__field">
                    <TextField
                        name="new-password"
                        value={newPassword}
                        placeholder="رمز عبور جدید"
                        onChange={(e) => setNewPassword(e.target.value)}
                        type="password"
                        label="رمز عبور جدید"
                    />
                </div>
                <div className="profile-edit__field">
                    <TextField
                        name="confirm-password"
                        value={confirmPassword}
                        placeholder="تایید رمز عبور"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        type="password"
                        label="تایید رمز عبور"
                    />
                </div>
                <div className="profile-edit__actions">
                    <button
                        type="button"
                        className="profile-edit__submit"
                        onClick={handleUpdatePassword}
                        disabled={isLoading}
                    >
                        {isLoading ? <div className="loader"></div> : "ویرایش رمز عبور"}
                    </button>
                </div>
            </div>
        </div>

        {openAvatarPicker && (
            <AvatarPickerDialog
                selectedAvatar={avatar}
                onSelect={setAvatar}
                onClose={() => setOpenAvatarPicker(false)}
            />
        )}
        </>
    );
}
